import { getPoolDeviceClass } from '../../pooldevice';
import { ButtonMappingTypes } from '../documents/ButtonMappings';
import { DeviceTypes } from '../documents/HardwareConfig';
import Locale from "../../utils/Locale";

export function getDeviceNameLocalised(deviceType: DeviceTypes): string {
    const PoolDeviceClass = getPoolDeviceClass(deviceType);
    if (PoolDeviceClass) {
        return PoolDeviceClass.default.PickerTitle;
    }
    return deviceType;
}

export function getButtonMappingTypesLocalized(mappingType: ButtonMappingTypes): string {
    switch(mappingType) {
    case ButtonMappingTypes.DECREASE: return Locale.gettext("Decrease");
    case ButtonMappingTypes.INCREASE: return Locale.gettext("Increase");
    case ButtonMappingTypes.SET_NO_TOGGLE: return Locale.gettext("Set");
    case ButtonMappingTypes.SET: return Locale.gettext("Set and Toggle On/Off");
    case ButtonMappingTypes.TOGGLE_STATUS: return Locale.gettext("Toggle On/Off");
    default: return mappingType;
    }
}
